//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

import { useTranslation } from "react-i18next";
import { useCurrentProductVariant } from "../useCurrentProductVariant";
import { BERNINA_CLOUD, MELCO_CLOUD } from "../../helper/commonHelper";

import Logo from "../../assets/logo.svg";
import berninalogo from "../../assets/bernina_logo.svg";
import LogoCollapsed from "../../assets/logo_collapsed.svg";
import {
  BERNINA_EMAIL_HISTORY_PRODUCT_CODES,
  MELCO_EMAIL_HISTORY_PRODUCT_CODES,
} from "../../helper/emailhistoryHelper";
import {
  BERNINA_PRODUCT_CONTROL_CENTER_TABS,
  BERNINA_PRODUCT_TOOLBOX_CLOUD_TABS,
  BERNINA_PRODUCT_TOOLBOX_TABS,
  MELCO_PRODUCT_ACCOUNT_TABS,
  MELCO_PRODUCT_API_SERVICE_TABS,
  MELCO_PRODUCT_CONTROL_CENTER_TABS,
  MELCO_PRODUCT_DESIGNSHOP_TABS,
  MELCO_PRODUCT_EFS_TABS,
  MELCO_PRODUCT_FUSION_TABS,
  MELCO_PRODUCT_SUMMIT_MANAGER_TABS,
  MELCO_PRODUCT_MACHINECLOUD_TABS,
  MELCO_PRODUCT_MATTERHORN_TABS,
  ProductTabsType,
} from "../../helper/usersHelper";
import {
  BERNINA_PRESSER_FOOT,
  MELCO_PRESSER_FOOT,
} from "../../helper/hoopHelper";

export const useAppDomain = () => {
  const { t } = useTranslation();
  const productVariant = useCurrentProductVariant();

  let footertext = "";
  let appTitle = "";
  let logoSelected = "";
  let collapsedLogoSelected = "";
  let allEmailHistoryProductCodes = "";
  let productTabs: ProductTabsType<string> = {};
  let pressureFootOptions = "";

  // Footer Text
  if (productVariant === MELCO_CLOUD) {
    footertext = t(`footer.copyright.melco_cloud`, {
      copyrightYear: new Date().getFullYear(),
    });
    appTitle = t("common.melco_cloud");
    logoSelected = Logo;
    collapsedLogoSelected = LogoCollapsed;
    allEmailHistoryProductCodes = MELCO_EMAIL_HISTORY_PRODUCT_CODES;
    productTabs = {
      API_SERVICE: MELCO_PRODUCT_API_SERVICE_TABS,
      FUSION: MELCO_PRODUCT_FUSION_TABS,
      EFS: MELCO_PRODUCT_EFS_TABS,
      MATTERHORN: MELCO_PRODUCT_MATTERHORN_TABS,
      ACCOUNT: MELCO_PRODUCT_ACCOUNT_TABS,
      CONTROL_CENTER: MELCO_PRODUCT_CONTROL_CENTER_TABS,
      DESIGNSHOP: MELCO_PRODUCT_DESIGNSHOP_TABS,
      SUMMIT_MANAGER: MELCO_PRODUCT_SUMMIT_MANAGER_TABS,
      MACHINECLOUD: MELCO_PRODUCT_MACHINECLOUD_TABS,
    };
    pressureFootOptions = MELCO_PRESSER_FOOT;
  } else if (productVariant === BERNINA_CLOUD) {
    footertext = t(`footer.copyright.bernina_cloud`, {
      copyrightYear: new Date().getFullYear(),
    });
    appTitle = t("common.bernina_cloud");
    logoSelected = berninalogo;
    collapsedLogoSelected = berninalogo;
    allEmailHistoryProductCodes = BERNINA_EMAIL_HISTORY_PRODUCT_CODES;
    productTabs = {
      CONTROL_CENTER: BERNINA_PRODUCT_CONTROL_CENTER_TABS,
      TOOLBOX_CLOUD: BERNINA_PRODUCT_TOOLBOX_CLOUD_TABS,
      TOOLBOX: BERNINA_PRODUCT_TOOLBOX_TABS,
    };
    pressureFootOptions = BERNINA_PRESSER_FOOT;
  }

  //   // App Title
  //   if (productVariant === MELCO_CLOUD) {
  // appTitle = t('common.melco_cloud')
  //   }
  //   else if (productVariant === BERNINA_CLOUD) {
  //    // appTitle = t('common.bernina_cloud')
  //   };

  //   // App Title
  //   if (productVariant === MELCO_CLOUD) {
  //  //   logoSelected = (Logo);
  //    // collapsedLogoSelected = (LogoCollapsed);
  //   }
  //   else if (productVariant === BERNINA_CLOUD) {
  //   //  logoSelected = berninalogo;
  //   //  collapsedLogoSelected = berninalogo;
  //   };

  //   // Email History Product Code
  //   if (productVariant === MELCO_CLOUD) {
  //    // allEmailHistoryProductCodes = MELCO_EMAIL_HISTORY_PRODUCT_CODES ;
  //   }
  //   else if (productVariant === BERNINA_CLOUD) {
  //   //  allEmailHistoryProductCodes = BERNINA_EMAIL_HISTORY_PRODUCT_CODES ;
  //   };

  return {
    footertext,
    appTitle,
    logoSelected,
    collapsedLogoSelected,
    allEmailHistoryProductCodes,
    productTabs,
    pressureFootOptions,
  };
};
